'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../../Styles/makeStyles.js');
var InputBase = require('../../../node_modules/@material-ui/core/esm/InputBase/InputBase.js');
var colorManipulator = require('../../../node_modules/@material-ui/core/esm/styles/colorManipulator.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {
      '& > svg': {
        right: 7
      },
      padding: '8px 16px',
      borderRadius: 32,
      '& $input': {
        paddingRight: 32,
        background: 'transparent'
      },
      border: "1px solid ".concat(colorManipulator.fade(theme.palette.brandPrimary.main, 0.4))
    },
    filled: {
      background: theme.palette.brandPrimary.main,
      color: theme.palette.getContrastText(theme.palette.brandPrimary.main),
      '&:hover': {
        background: colorManipulator.fade(theme.palette.brandPrimary.main, 1 - theme.palette.action.hoverOpacity)
      },
      '&$focused': {
        background: colorManipulator.fade(theme.palette.brandPrimary.main, 1 - theme.palette.action.focusOpacity)
      },
      '& > svg': {
        color: theme.palette.getContrastText(theme.palette.brandPrimary.main)
      }
    },
    outlined: {
      background: 'transparent',
      color: theme.palette.brandPrimary.main,
      '&:hover': {
        background: colorManipulator.fade(theme.palette.secondary.light, theme.palette.action.hoverOpacity)
      },
      '&$focused': {
        background: colorManipulator.fade(theme.palette.secondary.light, theme.palette.action.focusOpacity)
      },
      '& > svg': {
        color: theme.palette.brandPrimary.main
      }
    },
    input: {},
    focused: {}
  };
});

var PillInput = function PillInput(_ref) {
  var variant = _ref.variant,
      propClasses = _ref.classes,
      restOfProps = objectWithoutProperties(_ref, ["variant", "classes"]);

  var _ref2 = propClasses || {},
      propRootClass = _ref2.root,
      restPropClasses = objectWithoutProperties(_ref2, ["root"]);

  var _useStyles = useStyles(restOfProps),
      filled = _useStyles.filled,
      outlined = _useStyles.outlined,
      root = _useStyles.root,
      restOfClasses = objectWithoutProperties(_useStyles, ["filled", "outlined", "root"]);

  return React__default["default"].createElement(InputBase["default"], _objectSpread({
    classes: _objectSpread({
      root: classNames__default["default"](root, filled, defineProperty({}, outlined, variant === 'outlined'), propRootClass)
    }, restOfClasses, {}, restPropClasses)
  }, restOfProps));
};

module.exports = PillInput;
